import { VtoSubcategory } from "@hermes/api-model-virtual-try-on";

import { VtoModalStatus, VtoSdkError } from "../types/vto.types";

export interface LocalizedVtoCategory {
    vtoCategoryType: string | "NO_SELECT";
    localizedVtoCategoryType: string;
    vtoSubcategories: LocalizedVtoSubcategory[];
    selectedSubcategoryType: string;
}

export type LocalizedVtoSubcategory = VtoSubcategory & {
    localizedVtoSubcategoryType: string;
    selectedSkuVariant: string;
};

export interface VtoCategoriesConfiguration {
    currentVtoSku: string;
    skuApplied: SkuApplied;
}

export interface VtoModalConfiguration {
    sdkError: VtoSdkError;
    modalStatus: VtoModalStatus;
    isApproval: boolean;
}

export const NO_SELECT = "NO_SELECT";
export const NO_SHADE = "NO_SHADE";
export const NO_CATEGORY: LocalizedVtoCategory = {
    vtoCategoryType: NO_SELECT,
    localizedVtoCategoryType: "",
    vtoSubcategories: [],
    selectedSubcategoryType: NO_SELECT,
};

export const NO_SUBCATEGORY: LocalizedVtoSubcategory = {
    vtoSubcategoryType: NO_SELECT,
    localizedVtoSubcategoryType: "",
    vtoProducts: [],
    selectedSkuVariant: NO_SELECT,
};

export interface SkuApplied {
    [key: string]: string;
}
